module.exports = "query DepartementsQuery{departements{edges{node{id rowId codeDept nomDept}}}}"